import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import colors from '../Theme/colors';

const premiumPropertyTypes = {
  fillColor: PropTypes.string,
  size: PropTypes.number,
};

type PremiumProperties = InferProps<typeof premiumPropertyTypes> & {
  fillColor?: string;
  size?: number;
};

const Premium = ({
  fillColor = colors.greyDark,
  size = 24,
}: PremiumProperties) => (
  <svg
    viewBox={`0 0 ${size} ${size}`}
    width={size}
    height={size}
  >
    <title>Premium</title>
    <g
      transform={`scale(${size / 52} ${size / 52})`}
    >
      <path
        d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
        fill={fillColor}
      />
    </g>
  </svg>
);

Premium.propTypes = premiumPropertyTypes;

export default Premium;
